import { Center, Grid, Loader, Skeleton } from '@mantine/core'
import { useUserRole } from '@ospace/auth'
import { useClient } from '@ospace/client'
import { isClientTeamsAvailableToUserRole } from '@ospace/core-auth'
import { SelectedPage, useNavLayout } from '@ospace/layout'
import { ErrorBoundary } from '@ospace/shared'
import { useUser } from '@ospace/user'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { MemberList } from '../components/MemberList'
import { useTeams } from '../hooks'

const SkeletonLoader = () => (
  <Grid>
    <Grid.Col span={4} bg={'#fff'}>
      <Skeleton height={200} radius='md' />
    </Grid.Col>
    <Grid.Col span={4} bg={'#fff'}>
      <Skeleton height={200} radius='md' />
    </Grid.Col>
    <Grid.Col span={4} bg={'#fff'}>
      <Skeleton height={200} radius='md' />
    </Grid.Col>
  </Grid>
)
export const MyTeamsPage = ({ clientId }: { clientId: number }) => {
  const { setLayoutConfig } = useNavLayout()

  useEffect(() => {
    setLayoutConfig({ pageId: 'my-teams', pageTitle: 'My teams' })
  }, [setLayoutConfig])

  const userRole = useUserRole()
  const navigate = useNavigate()
  const { isLoading: isLoadingClient, data: client } = useClient(clientId)
  const { isLoading: isLoadingUser, data: user } = useUser()
  const { isLoading: isLoadingTeams, data: teamMembers } = useTeams(clientId)

  if (isLoadingClient || !client || isLoadingUser || !user) {
    return (
      <Center style={{ minHeight: '100vh' }} h='100vh' mx='auto'>
        <Loader variant='bars' />
      </Center>
    )
  }

  if (!isClientTeamsAvailableToUserRole({ userRole, client })) {
    navigate('/error/403')
  }

  return (
    <>
      <SelectedPage>My Teams</SelectedPage>
      {isLoadingTeams || !teamMembers ? (
        <SkeletonLoader />
      ) : (
        <MemberList teamMembers={teamMembers} />
      )}
    </>
  )
}

const Controller = () => {
  const params = useParams()
  const clientId = Number(params?.clientId)

  return <MyTeamsPage clientId={clientId} />
}

export const MyTeamsPageHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
